import { render, staticRenderFns } from "./alertWithImage.vue?vue&type=template&id=7f963ef1&scoped=true"
import script from "./alertWithImage.vue?vue&type=script&lang=js"
export * from "./alertWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f963ef1",
  null
  
)

export default component.exports